import * as Sentry from '@sentry/react';
import axios from 'axios';
import { CONFIG_FILE_URL } from './core/config-loader/consts/config-file-url';

const response = await axios.get(CONFIG_FILE_URL);
const isLocalEnvironment = response.data.environment === 'local';
const appVersion = response.data.appVersion;

if (!isLocalEnvironment) {
  Sentry.init({
    dsn: 'https://e0fa5c77dcd0cd0d190c2ed405af06b6@o4506864196517888.ingest.us.sentry.io/4511732670726144',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // If `true`, Sentry will try to print out useful debugging information if something goes wrong with sending the event. Set it to `false` in production
    debug: !isLocalEnvironment,
    environment: response.data.environment,
    release: appVersion,
    sampleRate: 1,
    tracesSampleRate: 1, // The percentage of transactions that will be sent to Sentry. Default is 1.0, meaning that 100% of transactions are sent.
    normalizeDepth: 3, // This is the default level 3, or however deep you want your state context to be

    // Set Replay sample rates
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      const error = hint?.originalException;

      // Axios / fetch style: error.response.status
      if (error?.response?.status === 401) return null;

      // Express / API errors: error.status || error.statusCode
      if (error?.status === 401 || error?.statusCode === 401) return null;

      // If Sentry parsed the HTTP info into event.contexts
      const status = event?.contexts?.response?.status;
      if (status === 401) return null;

      return event;
    },
  });
}
